import {matchPath} from 'react-router-dom'

import {routeArray, RouteData, routeMap} from './route-config'

const checkRole = (roles: Role[], route: RouteData) =>
  route.userRoles.some(r => roles.includes(r))

const matches = (url: string, path: string) =>
  matchPath(path, url) != null

export const hasMatch = (roles: Role[], url: string) =>
  routeMap.has(url)
    ? checkRole(roles, routeMap.get(url)!)
    : routeArray.some((r) => checkRole(roles, r) && matches(url, r.path))

export const hasAccess = (roles: Role[], url: string) => {
  const checkRoute = (route: RouteData) => checkRole(roles, route)

  return routeMap.has(url)
    ? checkRoute(routeMap.get(url)!)
    : routeArray.some((r) => checkRoute(r) && matches(url, r.path))
}
